import { css } from '@emotion/css';

export const tableContainer = css({
  display: 'block',
  padding: '10px 0 18px 10px',
  overflowX: 'auto',
  overflowY: 'visible',
  '::-webkit-scrollbar': {
    height: '8px',
  },
  '::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'transparent',
  },
  '::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'transparent',
    height: '8px',
  },
  '&:hover::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'var(--affine-black-30)',
  },
  '&:hover::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'var(--affine-hover-color)',
    height: '8px',
  },
});

export const tableContainerWithStickyScrollbar = css({
  scrollbarWidth: 'none',
  '::-webkit-scrollbar': {
    display: 'none',
  },
});

export const tableWrapper = css({
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  position: 'relative',
  width: 'max-content',
});

export const table = css({});

export const rowStyle = css({});

// A sticky proxy scrollbar that mirrors the horizontal scroll of the table.
// It sticks to the bottom of the viewport while the table is on screen, so the
// user does not have to scroll to the very bottom of a tall table to reach the
// native horizontal scrollbar.
export const stickyScrollbar = css({
  position: 'sticky',
  bottom: '0',
  left: '0',
  zIndex: 1,
  overflowX: 'auto',
  overflowY: 'hidden',
  // Only take space for the scrollbar itself.
  height: '12px',
  display: 'none',
  '&[data-enabled="true"][data-visible="true"]': {
    display: 'block',
  },
  '::-webkit-scrollbar': {
    height: '8px',
  },
  '::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'var(--affine-black-30)',
  },
  '::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'var(--affine-hover-color)',
    height: '8px',
  },
});

export const stickyScrollbarInner = css({
  height: '1px',
});
